import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { appInsights } from "./telemetry";

/** Tracks a page view on every route change. Call once, near the root of the app —
 *  must run inside <BrowserRouter> since it reads the current location. */
export function usePageViewTracking() {
  const location = useLocation();

  useEffect(() => {
    appInsights.trackPageView({ uri: location.pathname + location.search });
  }, [location.pathname, location.search]);
}
